"use client";

import React, { useState } from "react";
import { TeamMember } from "@/payload-types";
import { CardsGridSection } from "@itchannelplus/ui/sections/CardsGridSection";
import { HorizontalSlidingCardsSection } from "@itchannelplus/ui/sections/HorizontalSlidingCardsSection";
import { CardProps, ICard } from "@itchannelplus/ui/components/Card/types";
import { SimpleLinkProps } from "@itchannelplus/utils";
import Modal from "@itchannelplus/ui/components/Modal";
import Image from "next/image";
import {
  ModalContentWrapper,
  ImgCol,
  ImgWrapper,
  ContentCol,
  MemberName,
  MemberJobTitle,
  MemberAboutMe,
} from "./styles";
import styles from "./styles.module.scss";

export interface TeamMembersSectionProps {
  title?: string;
  tagline?: string;
  displayType: "grid" | "slider";
  imageRatio?: CardProps["imageRatio"];
  teamMembers: (number | TeamMember)[];
  cta?: SimpleLinkProps;
}

export const TeamMembersSection: React.FC<TeamMembersSectionProps> = ({
  title,
  tagline,
  displayType,
  imageRatio,
  teamMembers,
  cta,
}) => {
  const [selectedMember, setSelectedMember] = useState<TeamMember | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const activeMembers = teamMembers.filter(
    (member): member is TeamMember =>
      typeof member !== "number" && !!member.isActive,
  );

  const cards: CardProps[] = activeMembers.map((member) => {
    const photo = member.photo as any;
    const image = photo?.src || photo?.url || "";

    return {
      title: member.name,
      caption: member.jobTitle,
      image: image,
      imageRatio: imageRatio,
      textPosition: "bottom",
      textAlign: "center",
/*      overlay: {
        text: member.aboutMe
          ? (member.aboutMe as any).replace(/<[^>]*>/g, "")
          : "",
      },*/
      onClick: () => {
        setSelectedMember(member);
        setIsModalOpen(true);
      },
      style: { cursor: "pointer" },
    };
  });

  const selectedMemberPhoto = selectedMember?.photo as any;
  const selectedMemberImage =
    selectedMemberPhoto?.src || selectedMemberPhoto?.url || "";

  return (
    <>
      {displayType === "slider" ? (
        <HorizontalSlidingCardsSection
          title={title}
          tagline={tagline}
          cards={cards as ICard[]}
          cta={cta}
        />
      ) : (
        <CardsGridSection
          title={title}
          tagline={tagline}
          cards={cards}
          cta={cta}
          cols={Math.min(4, cards.length) as any}
        />
      )}

      <Modal
        type="popup"
        isOpened={isModalOpen}
        appear="fade"
        onClose={() => setIsModalOpen(false)}
        theme="light"
        className={styles.teamMemberModal}
      >
        {selectedMember && (
          <ModalContentWrapper>
            <ImgCol>
              <ImgWrapper>
                {selectedMemberImage && (
                  <Image
                    src={selectedMemberImage}
                    alt={selectedMember.name}
                    fill
                    sizes="(max-width: 768px) 100vw, 350px"
                    priority
                  />
                )}
              </ImgWrapper>
            </ImgCol>
            <ContentCol>
              <MemberName>{selectedMember.name}</MemberName>
              <MemberJobTitle>{selectedMember.jobTitle}</MemberJobTitle>
              {selectedMember.aboutMe && (
                <MemberAboutMe
                  dangerouslySetInnerHTML={{
                    __html: selectedMember.aboutMe as any,
                  }}
                />
              )}
            </ContentCol>
          </ModalContentWrapper>
        )}
      </Modal>
    </>
  );
};

export default TeamMembersSection;
